/**
 * Checks whether a value is a finite number and ≥ 0.
 * @param {*} value — any value to test
 * @returns {boolean} — true if value is a number ≥ 0, otherwise false
 */
export const isNonNegativeNumber = (value?: number): boolean => typeof value === 'number' && Number.isFinite(value) && value >= 0;
